// Framework
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// Components
import { NotFoundComponent } from "@src/app/modules/share/components/not-found/not-found.component";
import { PublicBackboneComponent } from "./components/public-backbone/public-backbone.component";

const routes: Routes = [
    {
        path: "",
        component: PublicBackboneComponent,
        children: [
            {
                path: "",
                pathMatch: "full",
                redirectTo: "home",
            },
            // legal components
            {
                path: "legal-notice",
                loadChildren: () => import("../legal-notice/legal-notice.module").then((m) => m.LegalNoticeModule),
            },
            {
                path: "privacy-policy",
                loadChildren: () => import("../privacy-policy/privacy-policy.module").then((m) => m.PrivacyPolicyModule),
            },
            // contact
            {
                path: "contact",
                loadChildren: () => import("../contact/contact.module").then((m) => m.ContactModule),
            },
            // registration
            {
                path: "registration",
                loadChildren: () => import("../registration/registration.module").then((m) => m.RegistrationModule),
            },
            // home component
            {
                path: "home",
                loadChildren: () => import("../home/home.module").then((m) => m.HomeModule),
            },
            // not found component
            { path: "**", component: NotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PublicBackboneRoutingModule { }
